import React from "react";
import { Stack } from "@datanomik/commons-ui";
import { SendMoney } from "@datanomik/commons-ui/icons";
import AnimatedEntrance from "@/views/common/AnimatedEntrance";
import { CashPoolingBreadcrumbs } from "../../components/CashPoolingBreadcrumbs/CashPoolingBreadcrumbs";
import { RuleCreationPageLayout } from "../RuleCreationPageLayout";
import { RuleCreationTypeSelector } from "./RuleCreationTypeSelector";
import { useRuleCreationTypeSelector } from "./useRuleCreationTypeSelector";

/**
 * RuleCreationTypeSelectorPage component
 *
 * Page wrapper for selecting the type of cash pooling rule to create.
 * Uses AnimatedEntrance and RuleCreationPageLayout for consistent UI.
 *
 * Route: /cash-pooling/rule-creation
 */
export const RuleCreationTypeSelectorPage: React.FC = () => {
  const { onSelectExcessRule, onSelectMinimumRule, onSelectRecurrenceRule } =
    useRuleCreationTypeSelector();

  return (
    <AnimatedEntrance>
      <Stack
        spacing={3}
        sx={{
          maxWidth: "900px",
          width: "100%",
          margin: "0 auto",
          px: 4,
          py: 4,
        }}
      >
        <CashPoolingBreadcrumbs
          items={[
            { label: "Cash Pooling", path: "/cash-pooling" },
            {
              label: "Criação de Regra",
              path: "/cash-pooling/rule-creation",
            },
          ]}
        />

        <RuleCreationPageLayout
          header="Selecione o tipo de regra de saldo"
          subheader="Automatize transferências com base no saldo da sua conta."
          icon={<SendMoney />}
        >
          <RuleCreationTypeSelector
            onSelectExcessRule={onSelectExcessRule}
            onSelectMinimumRule={onSelectMinimumRule}
            onSelectRecurrenceRule={onSelectRecurrenceRule}
          />
        </RuleCreationPageLayout>
      </Stack>
    </AnimatedEntrance>
  );
};
